/*
 Copyright (c) 2018 Wells Fargo. 45 Fremont St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Jeremy Levy

 Description:
 */
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../lib/store/wf-cms/actions';
import { adapter } from '../../lib/store/wf-cms/data-adapter';

var mapStateToProps = function mapStateToProps(state, _ref) {
  var id = _ref.id;
  return {
    data: state.digitalCore.wfCms.getIn(['components', id, 'data']),
    isFetching: state.digitalCore.wfCms.getIn(['components', id, 'isFetching'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchCmsData: function fetchCmsData(cmsIds, url, onError) {
      return dispatch(actions.wfCmsRequestStart({
        cmsIds: cmsIds,
        url: url,
        onError: onError
      }));
    },
    setIndividualComponentData: function setIndividualComponentData(cmsId, cmsData, parseJson) {
      return dispatch(actions.wfCmsSetIndividualComponentData({
        cmsId: cmsId,
        data: adapter(cmsData, parseJson)
      }));
    },
    setIncludeComponents: function setIncludeComponents(includeComponents) {
      return dispatch(actions.wfCmsSetIncludeComponents(includeComponents));
    }
  };
};

var WFCmsContainer = function WFCmsContainer(Component) {
  return connect(mapStateToProps, mapDispatchToProps)(Component);
};

WFCmsContainer.propTypes = {
  id: PropTypes.string.isRequired
};
export default WFCmsContainer;